/**
 * Lucide icon names that are direction-sensitive (arrows, chevrons,
 * navigation, undo/redo, ...) and must be mirrored automatically when
 * rendered in an RTL context (Section 12.4 of the SRS).
 *
 * This list is intentionally maintained by hand rather than inferred,
 * since "looks like an arrow" is a design judgement, not something to
 * detect from the SVG path data.
 */
export const DIRECTIONAL_ICONS = new Set<string>([
  'arrow-left',
  'arrow-right',
  'circle-arrow-left',
  'circle-arrow-right',
  'arrow-big-left',
  'arrow-big-right',
  'chevron-left',
  'chevron-right',
  'chevrons-left',
  'chevrons-right',
  'circle-chevron-left',
  'circle-chevron-right',
  'corner-down-left',
  'corner-down-right',
  'corner-up-left',
  'corner-up-right',
  'undo',
  'redo',
  'undo-2',
  'redo-2',
  'log-in',
  'log-out',
  'send',
  'reply',
  'forward',
  'skip-back',
  'skip-forward',
  'move-left',
  'move-right',
  'trending-up',
  'trending-down',
  'align-left',
  'align-right',
  'indent-increase',
  'indent-decrease',
  'panel-left',
  'panel-right',
])
